import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { userDetail } from 'Stores/userDetail';
import Utils from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { ReactComponent as NotificationSpeakerIcon } from 'Assets/svg/notification-speaker.svg';
import ConfettiImg from 'Assets/png/confetti.png';
import TimerImg from 'Assets/png/timerImg.png';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { resendActivationLink } from 'Utils/commonApi';
import { trialUserOnboardingState } from 'Stores/trialUserOnboardingState';

const { MX_COMMON_EVENTS } = CONSTANTS;
const { LB_UPGRADE_CLICK } = MX_COMMON_EVENTS;

const EmailActivation = observer(() => {
  const { email } = userDetail.userInfo;
  const resendActivationEmailLink = () => {
    resendActivationLink(email);
  };
  return email !== null && email !== undefined ? (
    <div className="notification-bar-top email-vefiry">
      <div className="notification-content">
        Please check your inbox at {email} for your activation link.&nbsp;
        <div className="try-link" onClick={resendActivationEmailLink}>
          Resend Activation Link
        </div>
      </div>
    </div>
  ) : (
    ''
  );
});

const PaymenyPendingReview = observer(() => {
  return (
    <div className="notification-bar-top payment-pending-review">
      <div className="notification-content">
        <NotificationSpeakerIcon width={30} height={24} className="info-icon" />
        Your account is currently being setup, You will receive a confirmation
        from the Adapt team soon.
      </div>
    </div>
  );
});

const NewFeatureSuppressionList = observer(props => {
  return Utils.checkAndShowNewFeature(props) ? (
    <div className="notification-bar-top new-feature-section">
      <div className="notification-content">
        <div className="new-feature">New update!</div>
        <img src={ConfettiImg} alt="top100" />
        <div className="main-text">
          You can now create suppression lists to exclude email IDs or domains
          from your search results.
        </div>
        <Link to="/suppression-list" className="try-link">
          Try it now {'=>'}
        </Link>
      </div>
    </div>
  ) : (
    ''
  );
});

const TrialDaysLeft = observer(props => {
  const { trialEndDays } = trialUserOnboardingState;
  const handleUpgradeSoon = () => {
    Utils.mixpanelTrack(LB_UPGRADE_CLICK, { Source: 'banner' });
    Utils.redirectToLBPricingPage();
  };

  const handleCloseClick = () => {
    const callback = () => {
      userDetail.setShowNotificationType('');
    };
    trialUserOnboardingState.updateTrialOnboardingPopupActivity(
      false,
      { daysLeftPopupShown: 'COMPLETE' },
      callback,
    );
  };
  return (
    <div className="notification-bar-top trial-days-left-section">
      <div className="notification-content">
        <img src={TimerImg} alt="TimerImg" />
        <div className="main-text">
          You have{' '}
          <span className="pink-style">
            {trialEndDays} {trialEndDays > 1 ? 'days' : 'day'}
          </span>{' '}
          remaining in your trial. Please{' '}
          <span className="pink-style upgrade-soon" onClick={handleUpgradeSoon}>
            {' '}
            upgrade soon
          </span>{' '}
          to power your prospecting efforts
        </div>
        <div className="close-wrapper" onClick={handleCloseClick}>
          <CloseIcon />
        </div>
      </div>
    </div>
  );
});

const NotificationBar = observer(props => {
  const { notificationType = '' } = props;

  switch (notificationType) {
    case CONSTANTS.NOTIFICATION_BAR_TYPE.ACTIVATION:
      return <EmailActivation />;
    case CONSTANTS.NOTIFICATION_BAR_TYPE.PAYMENT_PENDING_REVIEW:
      return <PaymenyPendingReview />;
    case CONSTANTS.NOTIFICATION_BAR_TYPE.NEW_FEATURE.SUPPRESSION_LIST:
      return <NewFeatureSuppressionList {...props} />;
    case CONSTANTS.NOTIFICATION_BAR_TYPE.TRIAL_DAYS_LEFT_NOTIFICATION:
      return <TrialDaysLeft {...props} />;

    default:
      return '';
  }
});

export { NotificationBar };
export default NotificationBar;
